import React, { useEffect, useState } from "react";
import { loadMeta } from "@/lib/meta";
import { FIELDS } from "@/lib/fields";

// Airtable choice color tokens -> CSS. Bright/Dark = solid chip; Light1/2 = tinted chip.
const FAMILY = {
  blue: { bright: "#2D7FF9", light: "#CFDFFF", dark: "#1D4ED8" },
  cyan: { bright: "#18BFFF", light: "#C2F5FF", dark: "#0E7490" },
  teal: { bright: "#20D9D2", light: "#CCF2EC", dark: "#0F766E" },
  green: { bright: "#20C933", light: "#D1F7C4", dark: "#15803D" },
  yellow: { bright: "#FCB400", light: "#FFEAB6", dark: "#A16207" },
  orange: { bright: "#FF6F2C", light: "#FEE0C7", dark: "#C2410C" },
  red: { bright: "#F82B60", light: "#FFDCE5", dark: "#B91C1C" },
  pink: { bright: "#FF08C2", light: "#FFD9F3", dark: "#BE185D" },
  purple: { bright: "#8B46FF", light: "#EDE2FE", dark: "#6D28D9" },
  gray: { bright: "#666666", light: "#E5E5E5", dark: "#374151" },
};
const NEUTRAL = { bg: "#F1F5F9", text: "#475569", border: "#CBD5E1" };

export function styleForToken(token) {
  if (!token) return NEUTRAL;
  const m = token.match(/^([a-z]+?)(Bright|Light1|Light2|Dark1)$/i);
  if (!m) return NEUTRAL;
  const fam = FAMILY[m[1].toLowerCase()];
  if (!fam) return NEUTRAL;
  const variant = m[2].toLowerCase();
  if (variant === "bright" || variant === "dark1") {
    return { bg: fam.bright, text: "#FFFFFF", border: fam.bright };
  }
  return { bg: fam.light, text: fam.dark, border: fam.light };
}

export function StageChip({ stage, className = "" }) {
  const [colors, setColors] = useState(null);
  useEffect(() => {
    loadMeta()
      .then((m) => setColors(m.select_colors?.[FIELDS.LEAD_STAGE] || {}))
      .catch(() => setColors({}));
  }, []);
  if (!stage) return <span className="text-slate-400 text-xs">—</span>;
  const s = styleForToken(colors?.[stage]);
  return (
    <span
      data-testid={`stage-chip-${stage}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold tracking-wide border whitespace-nowrap ${className}`}
      style={{ backgroundColor: s.bg, color: s.text, borderColor: s.border }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: s.text }} />
      {stage}
    </span>
  );
}
